import React from "react";

function Nojoid() {
  return (
    <div>
      <h4 className="d-flex align-items-center justify-content-center text-center text-danger">
        Not found{" "}
      </h4>
    </div>
  );
}

export default Nojoid;
